import _Object$getPrototypeOf from "babel-runtime/core-js/object/get-prototype-of";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "babel-runtime/helpers/possibleConstructorReturn";
import _inherits from "babel-runtime/helpers/inherits";
/**
 * @param {Storage} storage
 * @param {function:any} storage.getItem
 * @param {function:void} storage.setItem
 * @param {function:void} storage.removeItem
 * @returns {function:Cache}
 */
function provideStorage(storage) {
  return function (Cache) {
    var StorageCache = function (_Cache) {
      _inherits(StorageCache, _Cache);

      function StorageCache(key) {
        _classCallCheck(this, StorageCache);

        return _possibleConstructorReturn(this, (StorageCache.__proto__ || _Object$getPrototypeOf(StorageCache)).call(this, storage, key));
      }

      return StorageCache;
    }(Cache);

    return StorageCache;
  };
}

export default provideStorage;


// WEBPACK FOOTER //
// ./node_modules/lyjs/es/cache/provideStorage.js